import { apiRequest } from '@/utils/api-request';

export interface TokenModelItem {
  model: string;
  tokens: number;
  cost_usd: number;
}

export interface TokenUserItem {
  user_id: string;
  tokens: number;
}

export interface TokenConsumptionByLabelItem {
  label_id: string;
  label_name: string;
  label_color: string | null;
  total_tokens: number;
  total_cost_usd: number;
}

export interface TokenConsumptionSeriesPoint {
  date: string; // YYYY-MM-DD
  by_model: Record<string, { tokens: number; cost_usd: number }>;
}

export interface TokenConsumptionRequest {
  start_date?: string; // YYYY-MM-DD
  end_date?: string; // YYYY-MM-DD
  label_ids?: string[];
}

export interface TokenConsumptionResponse {
  success: boolean;
  message: string;
  org_id: string;
  start_date: string | null;
  end_date: string | null;
  total_tokens: number;
  total_cost_usd: number;
  tokens_last_7_days: number;
  cost_last_7_days_usd: number;
  top_models: TokenModelItem[];
  top_users: TokenUserItem[];
  by_label: TokenConsumptionByLabelItem[];
  series: TokenConsumptionSeriesPoint[];
  /** False when Langfuse is unconfigured or the metrics query failed. */
  langfuse_available: boolean;
}

export async function getTokenConsumption(
  orgId: string,
  params?: TokenConsumptionRequest,
): Promise<TokenConsumptionResponse> {
  const response = await apiRequest<TokenConsumptionResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/token-consumption`,
    method: 'POST',
    target: 'workflow',
    body: (params || {}) as Record<string, unknown>,
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch token consumption metrics');
  }

  return response.data;
}
